import { MCQuestions, SceneObjectives } from "@/types/crime";
import { APP_ASSETS } from "@/types/supported-venue";
import { isUseLocalModel } from "@/utils/link-detection";

import { SCENE_ANIMATION_1 } from "src/const/simulation/simulation_animation_1";
import { SCENE_ANIMATION_2 } from "src/const/simulation/simulation_animation_2";
import { SCENE_ANIMATION_3 } from "src/const/simulation/simulation_animation_3";
import { SCENE_ANIMATION_4 } from "src/const/simulation/simulation_animation_4";
import { SCENE_ANIMATION_5 } from "src/const/simulation/simulation_animation_5";
import { SCENE_ANIMATION_6 } from "src/const/simulation/simulation_animation_6";
import { SCENE_ANIMATION_7 } from "src/const/simulation/simulation_animation_7";
import { SCENE_ANIMATION_8 } from "src/const/simulation/simulation_animation_8";

export const AUTOPLAY_SPEED = 0.5;

export const ALL_SCENES_DATA = [
  {
    sceneIndex: 0,
    animation: SCENE_ANIMATION_1.items,
    level: "L2",
    startTime: 50400,
    endTime: 50460,
    animationTotalTime: 8,
    povCharacters: ["prisoner", "victimM", "citizenF"],
    cameraLevel: [
      {
        time: 8,
        data: ["L2"],
      },
    ],
    messages: [
      "scene_0_msg1",
      "scene_0_msg2",
      // 'A frantic caller states:\n"There’s a man stabbing people near the Water Zone escalators at ELEMENTS! People are running everywhere! I saw at least one person bleeding badly!"',
      // "The Force Communications Centre (FCC) operator asks for the caller’s location and number of injured. The connection drops mid-call.",
    ],
    // topViewPosition: [2, 0.8, -1],
    topViewPosition: [2, 0.8, 1],
  },
  {
    sceneIndex: 1,
    animation: SCENE_ANIMATION_2.items,
    level: "L1",
    startTime: 51000,
    endTime: 51240,
    animationTotalTime: 7,
    povCharacters: ["police1", "police2"],
    cameraLevel: [
      {
        time: 7,
        data: ["L1"],
      },
    ],
    messages: [
      "scene_1_msg1",
      "scene_1_msg2",
      // "Your team reaches ELEMENTS",
      // "Mall security reports:\n\
      //       •   Attacker last seen near Wood Zone to Water Zone corridor\n\
      //       •   Two victims down\n\
      //       •   Attacker holding a kitchen knife\n\
      //       •   CCTV shows chaotic movement; attacker’s latest location uncertain",
    ],
    // topViewPosition: [-1, 0.2, -4],
    topViewPosition: [-1, 0.2, 4],
  },
  {
    sceneIndex: 2,
    animation: SCENE_ANIMATION_3.items,
    level: "L1",
    startTime: 51360,
    endTime: 51600,
    animationTotalTime: 6.5,
    povCharacters: ["prisoner"],
    cameraLevel: [
      {
        time: 6.5,
        data: ["L1"],
      },
    ],
    messages: [
      "scene_2_msg1",
      // "CCTV shows the attacker moving toward the Metal Zone corridor, still armed. One injured victim is conscious but bleeding on the floor. Shoppers are hiding inside shops.",
    ],
    // topViewPosition: [1.7, 0.2, -0.5],
    topViewPosition: [1.7, 0.2, 0.5],
  },
  {
    sceneIndex: 3,
    animation: SCENE_ANIMATION_4.items,
    level: "L1",
    startTime: 51600,
    endTime: 51720,
    animationTotalTime: 5,
    povCharacters: ["prisoner", "police3"],
    cameraLevel: [
      {
        time: 5,
        data: ["L1"],
      },
    ],
    messages: [
      "scene_3_msg1",
      // "You spot the attacker approximately 20 meters ahead. He is pacing, gripping the knife, shouting incoherent phrases. Civilians are hiding.",
    ],
    // topViewPosition: [5.5, 0.2, 1.5],
    topViewPosition: [5.5, 0.2, -1.5],
  },
  {
    sceneIndex: 4,
    animation: SCENE_ANIMATION_5.items,
    level: "L1",
    startTime: 51720,
    endTime: 51780,
    animationTotalTime: 5.5,
    povCharacters: ["prisoner", "police3", "police4"],
    cameraLevel: [
      {
        time: 5.5,
        data: ["L1"],
      },
    ],
    messages: [
      "scene_4_msg1",
      // "The attacker charges toward a civilian. Police draw their firearm, issue a clear verbal command, and the attacker drops the weapon and surrenders.",
    ],
    // topViewPosition: [5.5, 0.2, 1.5],
    topViewPosition: [5.5, 0.2, -1.5],
  },
  {
    sceneIndex: 5,
    animation: SCENE_ANIMATION_6.items,
    level: "L1",
    startTime: 51780,
    endTime: 51840,
    animationTotalTime: 5,
    povCharacters: [],
    cameraLevel: [
      {
        time: 5,
        data: ["L1"],
      },
    ],
    messages: [
      "scene_5_msg1",
      // "Crowds gather at Metal Zone entrances. Media begins to arrive. Some civilians panic, trying to re-enter to look for friends.",
    ],
    // topViewPosition: [10, 0.2, 1.5],
    topViewPosition: [10, 0.2, -1.5],
  },
  {
    sceneIndex: 6,
    animation: SCENE_ANIMATION_7.items,
    level: "L2",
    startTime: 51900,
    endTime: 51960,
    animationTotalTime: 4,
    povCharacters: [],
    cameraLevel: [
      {
        time: 4,
        data: ["L2"],
      },
    ],
    messages: [
      "scene_6_msg1",
      // "Forensics arrives. ICTU is notified due to possible motive concerns. CCTV retrieval is underway with ELEMENTS control room.",
    ],
    topViewPosition: [2, 0.8, 0],
  },
  {
    sceneIndex: 7,
    animation: SCENE_ANIMATION_8.items,
    level: "L2",
    startTime: 51960,
    endTime: 52020,
    animationTotalTime: 5,
    povCharacters: [],
    cameraLevel: [
      {
        time: 5,
        data: ["L1"],
      },
    ],
    messages: [
      "scene_7_msg1",
      // "HKPF senior officers prepare a press briefing at ELEMENTS entrance near Water Zone.",
    ],
    // topViewPosition: [-1, 0.2, -4],
    topViewPosition: [-1, 0.2, 4],
  },
];

const modelBase = isUseLocalModel()
  ? "model/crime/"
  : `${APP_ASSETS}/crime_simulation/elements/`;

export const LOD = modelBase + "lod/lod-meta.json";
export const SOG_L1 = modelBase + "simulation_elements_l1.sog";
export const SOG_L2 = modelBase + "simulation_elements_l2.sog";

export const GLB_POLICE = modelBase + "police.glb";
export const GLB_PRISONER = modelBase + "prisoner.glb";
export const GLB_VICTIM_M = modelBase + "victimM.glb";
export const GLB_VICTIM_F = modelBase + "victimF.glb";
export const GLB_CORDON = modelBase + "cordon.glb";
export const GLB_CITIZEN_F = modelBase + "citizenF.glb";
export const GLB_CITIZEN_M = modelBase + "citizenM.glb";
export const GLB_SECURITY = modelBase + "security.glb";
export const GLB_PARAMEDIC = modelBase + "paramedic.glb";
export const GLB_FORENSIC = modelBase + "forensics.glb";
export const GLB_REPORTER = modelBase + "reporter.glb";
export const GLB_SENIOR = modelBase + "senior.glb";
export const GLB_ICTU = modelBase + "ictu.glb";

export const SPLAT_MAIN = modelBase + "element.splat";
export const SPLAT_L1 = modelBase + "element_L1.splat";
export const SPLAT_L2 = modelBase + "element_L2_20251202_1506.splat";
export const GLB_NAME = "model/crime/name.glb";

export const AVATAR_DATA = [
  {
    type: "prisoner",
    displayName: "Attacker",
    image: "icon_prisoner.png",
    color: "#FF0EE7",
  },
  {
    type: "victimM",
    displayName: "Victim",
    image: "icon_victim_m.png",
    color: "#FFD400",
  },
  {
    type: "victimF",
    displayName: "Victim",
    image: "icon_victim_f.png",
    color: "#FFD400",
  },
  {
    type: "citizenF",
    displayName: "Civilian",
    image: "icon_citizen_f.png",
    color: "#ABFFD8",
  },
  {
    type: "citizenM",
    displayName: "Civilian",
    image: "icon_citizen_m.png",
    color: "#ABFFD8",
  },
  {
    type: "police",
    displayName: "Police",
    image: "icon_police.png",
    color: "#20C7FF",
  },
  {
    type: "security",
    displayName: "Security",
    image: "icon_security.png",
    color: "#8262FF",
  },
  {
    type: "paramedic",
    displayName: "Paramedic",
    image: "icon_paramedic.png",
    color: "#FF6200",
  },
  {
    type: "reporter",
    displayName: "Reporter",
    image: "icon_reporter.png",
    color: "#F0B9F4",
  },
  {
    type: "forensic",
    displayName: "Forensic",
    image: "icon_forensic.png",
    color: "#81FD42",
  },
  {
    type: "senior",
    displayName: "HKPF senior officer",
    image: "icon_senior.png",
    color: "#2A30E2",
  },
  {
    type: "ictu",
    displayName: "ICTU",
    image: "icon_ictu.png",
    color: "#CA640B",
  },
];

export const APPEAR_CHARACTER = [
  {
    name: "prisoner",
    type: "prisoner",
    modelPath: GLB_PRISONER,
    topViewExtraY: 0.1,
  },
  {
    name: "victimM",
    type: "victimM",
    modelPath: GLB_VICTIM_M,
  },
  {
    name: "victimF",
    type: "victimF",
    modelPath: GLB_VICTIM_F,
  },
  {
    name: "police1",
    type: "police",
    modelPath: GLB_POLICE,
  },
  {
    name: "police2",
    type: "police",
    modelPath: GLB_POLICE,
  },
  {
    name: "police3",
    type: "police",
    modelPath: GLB_POLICE,
  },
  {
    name: "police4",
    type: "police",
    modelPath: GLB_POLICE,
  },
  {
    name: "police5",
    type: "police",
    modelPath: GLB_POLICE,
  },
  {
    name: "police6",
    type: "police",
    modelPath: GLB_POLICE,
  },
  {
    name: "police7",
    type: "police",
    modelPath: GLB_POLICE,
  },
  {
    name: "police8",
    type: "police",
    modelPath: GLB_POLICE,
  },
  {
    name: "security",
    type: "security",
    modelPath: GLB_SECURITY,
  },
  {
    name: "citizenM",
    type: "citizenM",
    modelPath: GLB_CITIZEN_M,
  },
  {
    name: "citizenF",
    type: "citizenF",
    modelPath: GLB_CITIZEN_F,
  },
  {
    name: "citizenM2",
    type: "citizenM",
    modelPath: GLB_CITIZEN_M,
  },
  {
    name: "citizenF2",
    type: "citizenF",
    modelPath: GLB_CITIZEN_F,
  },
  {
    name: "citizenM3",
    type: "citizenM",
    modelPath: GLB_CITIZEN_M,
  },
  {
    name: "citizenF3",
    type: "citizenF",
    modelPath: GLB_CITIZEN_F,
  },
  {
    name: "cordon",
    type: "cordon",
    modelPath: GLB_CORDON,
  },
  {
    name: "reporter1",
    type: "reporter",
    modelPath: GLB_REPORTER,
  },
  {
    name: "reporter2",
    type: "reporter",
    modelPath: GLB_REPORTER,
  },
  {
    name: "reporter3",
    type: "reporter",
    modelPath: GLB_REPORTER,
  },
  {
    name: "reporter4",
    type: "reporter",
    modelPath: GLB_REPORTER,
  },
  {
    name: "forensic1",
    type: "forensic",
    modelPath: GLB_FORENSIC,
  },
  {
    name: "senior",
    type: "senior",
    modelPath: GLB_SENIOR,
  },
  {
    name: "ictu",
    type: "ictu",
    modelPath: GLB_ICTU,
  },
];

export const CRIME_MC_QUESTIONS: MCQuestions[] = [
  {
    scene: 0,
    question: "scene_0_mcq1", // "How should FCC classify this incident?",
    options: [
      {
        choice: "A",
        answer: "scene_0_mcq1_option1", // "Minor assault requiring routine patrol response",
      },
      {
        choice: "B",
        answer: "scene_0_mcq1_option2", // "Dispute with possible weapon",
      },
      {
        choice: "C",
        answer: "scene_0_mcq1_option3", // "Serious violence incident / active attacker scenario",
      },
      {
        choice: "D",
        answer: "scene_0_mcq1_option4", // "Attempted robbery",
      },
    ],
    correct: "C",
    explanation: "scene_0_mcq1_explanation",
    // "Multiple victims + edged weapon = active attacker / serious violence classification, requiring urgent response.",
  },
  {
    scene: 0,
    question: "scene_0_mcq2", //"Which units should be deployed immediately?",
    options: [
      {
        choice: "A",
        answer: "scene_0_mcq2_option1", // "Only regular Uniform Branch units",
      },
      {
        choice: "B",
        answer: "scene_0_mcq2_option2", // "EU Kowloon West + Uniform Branch + alert FSD",
      },
      {
        choice: "C",
        answer: "scene_0_mcq2_option3", //"Wait for confirmation from mall security before deploying",
      },
      {
        choice: "D",
        answer: "scene_0_mcq2_option4", //"Notify SDU first and delay uniformed deployment",
      },
    ],
    correct: "B",
    explanation: "scene_0_mcq2_explanation", //"HKPF protocol: nearest frontline units (UB + EU) must deploy immediately; FSD must be alerted early.",
  },
  {
    scene: 1,
    question: "scene_1_mcq1", // "What is your FIRST action on arrival?",
    options: [
      {
        choice: "A",
        answer: "scene_1_mcq1_option1", //  "Ask security to begin full mall evacuation",
      },
      {
        choice: "B",
        answer: "scene_1_mcq1_option2", // "Immediately enter the mall and run in the direction you think the attacker is in",
      },
      {
        choice: "C",
        answer: "scene_1_mcq1_option3", //  "Establish communication with mall security control room for CCTV, latest intel, routes",
      },
      {
        choice: "D",
        answer: "scene_1_mcq1_option4", // "Wait for SDU",
      },
    ],
    correct: "C",
    explanation: "scene_1_mcq1_explanation", //  "Coordinating with the security control room provides fast intel and avoids blind entry.",
  },
  {
    scene: 1,
    question: "scene_1_mcq2", // "What is the primary objective of the first responders?",
    options: [
      {
        choice: "A",
        answer: "scene_1_mcq2_option1", // "Evacuate the entire mall",
      },
      {
        choice: "B",
        answer: "scene_1_mcq2_option2", // "Establish a perimeter at all exits first",
      },
      {
        choice: "C",
        answer: "scene_1_mcq2_option3", // "Locate and stop the attacker",
      },
      {
        choice: "D",
        answer: "scene_1_mcq2_option4", // "Secure shops for property protection",
      },
    ],
    correct: "C",
    explanation: "scene_1_mcq2_explanation", // "In active attacker situations, stopping the threat is the highest priority.",
  },
  {
    scene: 2,
    question: "scene_2_mcq1", // "What is the correct prioritization?",
    options: [
      {
        choice: "A",
        answer: "scene_2_mcq1_option1", // "Provide first aid to the visible victim immediately",
      },
      {
        choice: "B",
        answer: "scene_2_mcq1_option2", // "Split the team: one handles the victim alone, the rest search for the attacker",
      },
      {
        choice: "C",
        answer: "scene_2_mcq1_option3", //"Continue moving toward the attacker; relay casualty location to FSD",
      },
      {
        choice: "D",
        answer: "scene_2_mcq1_option4", //"Stop moving and wait for reinforcements",
      },
    ],
    correct: "C",
    explanation: "scene_2_mcq1_explanation", // "First responders must neutralize the attacker; casualty care is relayed to FSD or secondary teams.",
  },
  {
    scene: 2,
    question: "scene_2_mcq2", // "What information should be continuously communicated to command?",
    options: [
      {
        choice: "A",
        answer: "scene_2_mcq2_option1", // "Only the number of casualties",
      },
      {
        choice: "B",
        answer: "scene_2_mcq2_option2", // "Only your team’s current location",
      },
      {
        choice: "C",
        answer: "scene_2_mcq2_option3", //"Attacker direction, weapon, behaviour, casualties, and safe access routes",
      },
      {
        choice: "D",
        answer: "scene_2_mcq2_option4", //"Nothing until the attacker is captured",
      },
    ],
    correct: "C",
    explanation: "scene_2_mcq2_explanation", //"Continuous situational updates support coordination, deployment, and FSD entry.",
  },
  {
    scene: 3,
    question: "scene_3_mcq1", // "What should you do FIRST?",
    options: [
      {
        choice: "A",
        answer: "scene_3_mcq1_option1", // "Immediately discharge your firearm",
      },
      {
        choice: "B",
        answer: "scene_3_mcq1_option2", //  "Verbally challenge the suspect from cover, identifying police presence",
      },
      {
        choice: "C",
        answer: "scene_3_mcq1_option3", //  "Rush the suspect with batons",
      },
      {
        choice: "D",
        answer: "scene_3_mcq1_option4", // "Allow civilians to negotiate",
      },
    ],
    correct: "B",
    explanation: "scene_3_mcq1_explanation", // "HKPF protocol emphasises clear verbal warnings when feasible and tactically safe.",
  },
  {
    scene: 3,
    question: "scene_3_mcq2", //"Under what condition can you escalate to firearm use?",
    options: [
      {
        choice: "A",
        answer: "scene_3_mcq2_option1", // "When the suspect refuses to drop the weapon",
      },
      {
        choice: "B",
        answer: "scene_3_mcq2_option2", // "When civilians are in immediate danger of serious harm or death",
      },
      {
        choice: "C",
        answer: "scene_3_mcq2_option3", //"When the suspect shouts threats",
      },
      {
        choice: "D",
        answer: "scene_3_mcq2_option4", //"When media cameras are not present",
      },
    ],
    correct: "B",
    explanation: "scene_3_mcq2_explanation", //"Lethal force only when there is an imminent threat to life.",
  },
  {
    scene: 4,
    question: "scene_4_mcq1", //"What should you do immediately after neutralising the attacker?",
    options: [
      {
        choice: "A",
        answer: "scene_4_mcq1_option1", //"High-five team members",
      },
      {
        choice: "B",
        answer: "scene_4_mcq1_option2", //"Stand down because the incident is over",
      },
      {
        choice: "C",
        answer: "scene_4_mcq1_option3", //"Secure the weapon, check attacker’s condition, and ensure no secondary attackers",
      },
      {
        choice: "D",
        answer: "scene_4_mcq1_option4", //"Leave the suspect untouched",
      },
    ],
    correct: "C",
    explanation: "scene_4_mcq1_explanation", // "Officers must secure the weapon, provide safety checks, and assess for additional threats.",
  },
  {
    scene: 4,
    question: "scene_4_mcq2", //"How should casualty treatment proceed?",
    options: [
      {
        choice: "A",
        answer: "scene_4_mcq2_option1", // "Police provide what care they can and prioritise severe bleeding while awaiting FSD",
      },
      {
        choice: "B",
        answer: "scene_4_mcq2_option2", //"Only FSD can touch victims",
      },
      {
        choice: "C",
        answer: "scene_4_mcq2_option3", //"Leave all casualties in place until investigation begins",
      },
      {
        choice: "D",
        answer: "scene_4_mcq2_option4", //"Move all casualties to one central point immediately",
      },
    ],
    correct: "A",
    explanation: "scene_4_mcq2_explanation", // "Police provide immediate bleeding control and triage, then hand off to FSD.",
  },
  {
    scene: 5,
    question: "scene_5_mcq1", //"What should officers do first in this phase?",
    options: [
      {
        choice: "A",
        answer: "scene_5_mcq1_option1", //"Allow all civilians to return inside briefly",
      },
      {
        choice: "B",
        answer: "scene_5_mcq1_option2", //"Establish inner and outer cordons",
      },
      {
        choice: "C",
        answer: "scene_5_mcq1_option3", //"Close all entrances without explanation",
      },
      {
        choice: "D",
        answer: "scene_5_mcq1_option4", //"Request mall management to handle crowd control alone",
      },
    ],
    correct: "B",
    explanation: "scene_5_mcq1_explanation", // "Standard protocol requires cordon establishment to secure investigation sites and manage flows.",
  },
  {
    scene: 5,
    question: "scene_5_mcq2", // "What key message should officers give to the public?",
    options: [
      {
        choice: "A",
        answer: "scene_5_mcq2_option1", // "“Everything is safe, please go back inside.”",
      },
      {
        choice: "B",
        answer: "scene_5_mcq2_option2", //"“No comment.”",
      },
      {
        choice: "C",
        answer: "scene_5_mcq2_option3", // "“Please remain calm, keep clear of the area, follow police instructions.”",
      },
      {
        choice: "D",
        answer: "scene_5_mcq2_option4", //"“Take your own videos for insurance purposes.”",
      },
    ],
    correct: "C",
    explanation: "scene_5_mcq2_explanation", //"Public reassurance + clear instructions prevent panic.",
  },
  {
    scene: 6,
    question: "scene_6_mcq1", // "What must be preserved at the scene?",
    options: [
      {
        choice: "A",
        answer: "scene_6_mcq1_option1", // "Only the weapon",
      },
      {
        choice: "B",
        answer: "scene_6_mcq1_option2", // "Everything: blood patterns, footprints, CCTV timestamps, dropped items",
      },
      {
        choice: "C",
        answer: "scene_6_mcq1_option3", // "Only the suspect’s clothing",
      },
      {
        choice: "D",
        answer: "scene_6_mcq1_option4", // "Nothing once photos are taken",
      },
    ],
    correct: "B",
    explanation: "scene_6_mcq1_explanation", // "Full preservation is required for accurate forensic reconstruction.",
  },
  {
    scene: 6,
    question: "scene_6_mcq2", // "What is the correct officer action with witnesses?",
    options: [
      {
        choice: "A",
        answer: "scene_6_mcq2_option1", //"Allow them to leave without taking details",
      },
      {
        choice: "B",
        answer: "scene_6_mcq2_option2", //"Ask them to upload their videos to social media",
      },
      {
        choice: "C",
        answer: "scene_6_mcq2_option3", //"Escort them to a designated witness area for statements",
      },
      {
        choice: "D",
        answer: "scene_6_mcq2_option4", // "Confiscate all mobile devices on sight",
      },
    ],
    correct: "C",
    explanation: "scene_6_mcq2_explanation", //  "Proper witness management ensures statements are taken orderly and legally.",
  },
  {
    scene: 7,
    question: "scene_7_mcq1", // "What key information is appropriate for public release?",
    options: [
      {
        choice: "A",
        answer: "scene_7_mcq1_option1", //  "Accurate casualty numbers, attacker’s status, reassurance of no ongoing threat",
      },
      {
        choice: "B",
        answer: "scene_7_mcq1_option2", // "Graphic details of injuries",
      },
      {
        choice: "C",
        answer: "scene_7_mcq1_option3", //  "Speculation about attacker’s motives",
      },
      {
        choice: "D",
        answer: "scene_7_mcq1_option4", // "Names and ID numbers of victims",
      },
    ],
    correct: "A",
    explanation: "scene_7_mcq1_explanation", // "HKPF must provide verified facts and reassurance while avoiding speculation and sensitive personal data.",
  },
];

export const CRIME_SCENE_OBJECTIVES: SceneObjectives[] = [
  {
    scene: 0,
    title: "scene_0_title", //"Initial 999 Call Received",
    objectives: "scene_0_objective", // "Correctly classify the incident and determine initial deployment actions.",
  },
  {
    scene: 1,
    title: "scene_1_title", // "Arrival at ELEMENTS (First Responders)",
    objectives: "scene_1_objective", // "Identify priorities upon arrival and coordinate effectively.",
  },
  {
    scene: 2,
    title: "scene_2_title", // "Movement Inside ELEMENTS",
    objectives: "scene_2_objective", // "Apply correct movement and interaction strategy.",
  },
  {
    scene: 3,
    title: "scene_3_title", // "Confrontation With the Attacker",
    objectives: "scene_3_objective",
    //"Apply HKPF use-of-force and de-escalation principles while ensuring safety.",
  },
  {
    scene: 4,
    title: "scene_4_title", // "Neutralisation & Immediate Post-Incident Actions",
    objectives: "scene_4_objective", //  "Secure the scene, begin casualty care, and maintain evidence integrity.",
  },
  {
    scene: 5,
    title: "scene_5_title", // "Securing ELEMENTS & Crowd Management",
    objectives: "scene_5_objective", //  "Ensure controlled evacuation, cordon setup, and public reassurance.",
  },
  {
    scene: 6,
    title: "scene_6_title", // "Investigation & Handover",
    objectives: "scene_6_objective", // "Maintain scene integrity and proper investigative workflow.",
  },
  {
    scene: 7,
    title: "scene_7_title", // "Final Public Communication Phase",
    objectives: "scene_7_objective", // "Understand communication protocol and public reassurance responsibilities.",
  },
];

export const CRIME_SCORE_RESULT = [
  {
    score: 14,
    text: "score_5", // "Tactical Excellence",
    stars: 5,
  },
  {
    score: 12,
    text: "score_4", //  "Operationally Proficient"
    stars: 4,
  },
  {
    score: 10,
    text: "score_3", //"Satisfactory",
    stars: 3,
  },
  {
    score: 8,
    text: "score_2", //"Needs Development",
    stars: 2,
  },
  {
    score: 0,
    text: "score_1", // "Remedial Training Required",
    stars: 1,
  },
];

export const CRIME_SCENE_STEPS = [
  {
    scene: 0,
    image: "assets/incident_1.png",
    title: "scene_0_title", //"Initial 999 Call Received",
    date: "Nov 19, 2025 (Wed)",
    location: "ELEMENTS mall, Water zone",
    avatars: ["prisoner", "victimF", "citizenF"],
    onClick: () => {},
  },
  {
    scene: 1,
    image: "assets/incident_2.png",
    title: "scene_1_title", //"Arrival at ELEMENTS (First Responders)",
    date: "Nov 19, 2025 (Wed)",
    location: "ELEMENTS mall, Water zone",
    avatars: ["police", "police", "security"],
    // description: (
    //     <>
    //         <ul className="list-disc ml-5">
    //             <li>
    //                 Shoppers / staff / MTR or Airport Express staff call
    //                 999.
    //             </li>
    //             <li>
    //                 Information gathered:
    //                 <ul className="list-disc ml-5">
    //                     <li>
    //                         [translate:Knife attack at ELEMENTS, near zone
    //                         e.g. Metal / Wood / Fire]
    //                     </li>
    //                     <li>Injured persons?</li>
    //                     <li>Attacker description / direction of travel</li>
    //                     <li>
    //                         Any indication of terrorism (slogans, multiple
    //                         attackers, etc.)
    //                     </li>
    //                 </ul>
    //             </li>
    //             <li>
    //                 Force Communications Centre classifies it as a serious
    //                 violent incident / active attacker and dispatches:
    //                 <ul className="list-disc ml-5">
    //                     <li>Uniform Branch units in Kowloon West Region</li>
    //                     <li>
    //                         Emergency Unit (EU) Kowloon West (fast-response
    //                         cars)
    //                     </li>
    //                     <li>
    //                         Alerts FSD for ambulance + possible Mass
    //                         Casualty Incident response.
    //                     </li>
    //                 </ul>
    //             </li>
    //             <li>
    //                 If there are early signs of terrorism, ICTU and
    //                 counter-terrorism units are notified very quickly.
    //             </li>
    //         </ul>
    //     </>
    // ),
    onClick: () => {},
  },
  {
    scene: 2,
    image: "assets/incident_3.png",
    title: "scene_2_title", // "Movement Inside ELEMENTS",
    date: "Nov 19, 2025 (Wed)",
    location: "ELEMENTS mall, Water Zone",
    avatars: ["prisoner", "victimF", "citizenM"],
    // description: (
    //     <>
    //         <div className="mb-2">
    //             Because ELEMENTS is integrated with Kowloon Station (Airport
    //             Express + Tung Chung Line) and Austin Station walkways,
    //             police and FSD have pre-planned access and rendezvous points
    //             (vehicle drop-offs, loading bays, etc.).
    //             <br />
    //             On arrival, first officers will typically:
    //         </div>
    //         <ul className="list-disc ml-6">
    //             <li>
    //                 Coordinate with mall security control room (CCTV, floor
    //                 plans, latest sighting of attacker).
    //             </li>
    //             <li>
    //                 Decide entry points that balance:
    //                 <ul className="list-disc ml-6">
    //                     <li>Speed to the attacker</li>
    //                     <li>
    //                         Avoiding congestion at main atrium and open
    //                         plazas
    //                     </li>
    //                     <li>
    //                         Interaction with MTR/Airport Express passenger
    //                         flows
    //                     </li>
    //                 </ul>
    //             </li>
    //         </ul>
    //         <div className="mt-2">
    //             Priority is to stop ongoing attacks, not to fully evacuate
    //             first.
    //         </div>
    //     </>
    // ),
    onClick: () => {},
  },
  {
    scene: 3,
    image: "assets/incident_4.png",
    title: "scene_3_title", //"Confrontation With the Attacker",
    date: "Nov 19, 2025 (Wed)",
    location: "ELEMENTS mall, Metal Zone",
    avatars: ["prisoner", "citizenM", "police"],
    // description: (
    //     <>
    //         <div className="mb-2">
    //             At a high level (skipping tactical detail):
    //         </div>
    //         <ul className="list-disc ml-5">
    //             <li>
    //                 Officers move towards the last known location of the
    //                 attacker in small teams.
    //             </li>
    //             <li>
    //                 They may:
    //                 <ul className="list-disc ml-5">
    //                     <li>
    //                         Issue loud verbal commands if there’s a chance
    //                         to make the suspect surrender.
    //                     </li>
    //                     <li>
    //                         Use non-lethal options (baton, pepper spray,
    //                         taser) if safe.
    //                     </li>
    //                     <li>
    //                         Use firearms if the attacker poses an immediate
    //                         lethal threat, following HKPF’s use-of-force
    //                         rules: force must be necessary, proportionate,
    //                         and cease once the threat stops.{" "}
    //                         <span className="underline">
    //                             Hong Kong Police Force+1
    //                         </span>
    //                     </li>
    //                 </ul>
    //             </li>
    //             <li>
    //                 If there’s suspicion of more than one attacker, parts of
    //                 the mall and connected transport nodes (Kowloon Station
    //                 concourse, bus terminus, taxi stands) can be locked down
    //                 and swept.
    //             </li>
    //         </ul>
    //         <div className="mt-2">
    //             If the incident is reclassified as a likely terrorist
    //             attack, specialist units (e.g. counter-terrorism / SDU) can
    //             take over the inner cordon while uniformed officers control
    //             the outer areas.
    //         </div>
    //     </>
    // ),
    onClick: () => {},
  },
  {
    scene: 4,
    image: "assets/incident_5.png",
    title: "scene_4_title", // "Neutralisation & Immediate Post-Incident Actions",
    date: "Nov 19, 2025 (Wed)",
    location: "ELEMENTS mall, Metal Zone",
    avatars: ["prisoner", "citizenM", "police", "police"],
    // description: (
    //     <>
    //         <div className="mb-2">In parallel:</div>
    //         <ul className="list-disc ml-5">
    //             <li>
    //                 FSD ambulances and fire crews deploy to ELEMENTS, aiming
    //                 to meet their response targets (12 minutes for emergency
    //                 ambulance in built-up areas).{" "}
    //                 <span className="underline">
    //                     Fire Services Department+1
    //                 </span>
    //             </li>
    //             <li>
    //                 Police and FSD use basic life support and triage:
    //                 <ul className="list-disc ml-5">
    //                     <li>
    //                         Severe bleeding → tourniquets, pressure
    //                         dressings
    //                     </li>
    //                     <li>Airway/breathing support</li>
    //                 </ul>
    //             </li>
    //             <li>
    //                 Casualties are moved from open areas (main atrium,
    //                 corridors) to casualty collection points (often loading
    //                 bays, car park areas, or designated refuge points)
    //                 before hospital transport.
    //             </li>
    //         </ul>
    //         <div className="mt-2">
    //             For a busy mall like ELEMENTS, this can be treated as a Mass
    //             Casualty Incident if victim numbers are high.
    //         </div>
    //     </>
    // ),
    onClick: () => {},
  },
  {
    scene: 5,
    image: "assets/incident_6.png",
    title: "scene_5_title", // "Securing ELEMENTS & Crowd Management",
    date: "Nov 19, 2025 (Wed)",
    location: "ELEMENTS mall, Metal Zone",
    avatars: [
      "police",
      "police",
      "citizenM",
      "citizenM",
      "citizenM",
      "citizenF",
      "citizenF",
      "citizenF",
      "reporter",
      "reporter",
    ],
    onClick: () => {},
  },
  {
    scene: 6,
    image: "assets/incident_7.png",
    title: "scene_6_title", //"Investigation & Handover",
    date: "Nov 19, 2025 (Wed)",
    location: "ELEMENTS mall, Water Zone",
    avatars: ["ictu", "forensic"],
    onClick: () => {},
  },
  {
    scene: 7,
    image: "assets/incident_8.png",
    title: "scene_7_title", //"Final Public Communication Phase",
    date: "Nov 19, 2025 (Wed)",
    location: "ELEMENTS mall, Water Zone",
    avatars: ["senior", "police", "police", "reporter", "reporter"],
    onClick: () => {},
  },
];
